import {changelogTheme, outlinedBoxStyle} from '@/Components/Changelogs/changelogTheme.js';
import ChangelogTitleBlock from '@/Components/Changelogs/ChangelogTitleBlock.jsx';
import {Box, ThemeProvider} from '@mui/material';
import * as React from 'react';

// Encadré coloré (contour + encart de titre) pour un contenu de changelog, dans le
// thème de couleur choisi sur l'entrée.
const ChangelogOutlinedBox = ({title, colorTheme, sx = {}, children}) => (
    <ThemeProvider theme={changelogTheme(colorTheme)}>
        <Box sx={(theme) => ({...outlinedBoxStyle(theme), mt: 2, px: 3, pt: 3, pb: 2, ...sx})}>
            <ChangelogTitleBlock title={title} />
            {children}
        </Box>
    </ThemeProvider>
);

export default ChangelogOutlinedBox;
